import dayjs from 'dayjs';
import i18next from 'i18next';
import * as Yup from 'yup';

/**
 * Start und Ende eines Abschnitts müssen innerhalb von `minDate`/`maxDate` liegen. Die Grenzen
 * kommen aus den Nachbarabschnitten, sind aber immer auf das Schuljahr geklemmt – ein Abschnitt
 * darf nie über den Schuljahresanfang bzw. das Schuljahresende hinausragen.
 *
 * Verglichen wird TAGESGENAU: die Formularwerte tragen je nach Herkunft unterschiedliche
 * Uhrzeiten (`new Date('2027-07-31')` ist UTC-Mitternacht, also 02:00 lokal), wodurch ein
 * Vergleich auf Zeitstempel-Ebene den Grenztag selbst fälschlich ausschliessen würde.
 */
export const timetableBlockSchema = ({ minDate, maxDate }: { minDate: Date; maxDate: Date }) =>
  Yup.object().shape({
    start: Yup.date()
      .required(i18next.t('validation.common.startRequired'))
      .test('start-not-before-min', i18next.t('validation.timetableBlock.startBeforePrevEnd'), (start) => {
        return !start || dayjs(start).isSameOrAfter(dayjs(minDate), 'day');
      }),
    end: Yup.date()
      .required(i18next.t('validation.common.endRequired'))
      .test('end-not-before-start', i18next.t('validation.timetableBlock.endBeforeStart'), function (end) {
        const start = this.parent.start;
        return !end || !start || dayjs(end).isSameOrAfter(dayjs(start), 'day');
      })
      .test('end-not-after-max', i18next.t('validation.timetableBlock.endAfterNextStart'), (end) => {
        return !end || dayjs(end).isSameOrBefore(dayjs(maxDate), 'day');
      }),
    timetables: Yup.array().required(i18next.t('validation.timetableBlock.timetablesRequired')),
  });
